module.exports = __webpack_public_path__ + "static/logotipo-letter-7a5879c8e0c4b3d037d28b0309ecace5.svg";